import { Component, OnInit, HostListener } from '@angular/core';
import { SuscribeRadio } from 'src/app/models/suscriberadio';
import { CategoryService } from 'src/app/services/category.service';
import { Category } from 'src/app/models/category';
import { of, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as firebase from 'firebase';
import { SuscriberadioService } from 'src/app/services/suscriberadio.service';
import { NgbDateStruct, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AnalitycsService } from 'src/app/services/analitycs.service';

@Component({
  selector: 'app-suscribete-new',
  templateUrl: './suscribete-new.component.html',
  styleUrls: ['./suscribete-new.component.scss']
})
export class SuscribeteNewComponent implements OnInit {
  @HostListener('window:beforeunload', ['$event'])
  unloadAnalytics($event: any) {
    this.analytics.logEvents("refresh: subscribe");
  }
  par: Observable<Category[]> = of(null);
  impar: Observable<Category[]> = of(null);
  model: SuscribeRadio = new SuscribeRadio;
  categorys: Observable<Category[]> = of(null);

  modelDate: NgbDateStruct;
  fechaNacimientoPlaceholder;
  date: { year: number, month: number };

  selected: Category[] = [];
  constructor(
    private categoryServ: CategoryService,
    private subsServ: SuscriberadioService,
    private calendar: NgbCalendar,
    private _snackBar: MatSnackBar,
    private parserFormatter: NgbDateParserFormatter,
    private analytics: AnalitycsService
  ) {



    this.model = {
      categoris: null,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      dateofBirth: null,
      deleted: false,
      email: '',
      lastname: '',
      name: ''
    }
    let date = this.parserFormatter.format(this.modelDate);
  }

  async ngOnInit() {
    this.analytics.logEvents("Subscribe enter");
    this.categorys = of(await this.categoryServ.getVisible());
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  valueChange(item: Category, $event) {
    if ($event.checked) {
      this.selected.push(item);
    } else {
      let find = this.selected.findIndex(value => value.id == item.id);
      this.selected.splice(find, 1);
    }
  }

  subscribe() {
    var add = true;
    if (this.selected.length == 0) {
      add = false;
    }
    if (!this.fechaNacimientoPlaceholder) {
      add = false;
    }
    if (this.model.email.trim().length == 0) {
      add = false;
    }
    if (this.model.name.trim().length == 0) {
      add = false;
    }
    if (this.model.lastname.trim().length == 0) {
      add = false;
    }
    if (add) {
      let categories = [];
      this.selected.forEach(element => {
        categories.push({ id: element.id, name: element.name });
      })

      this.model.dateofBirth=new Date(this.fechaNacimientoPlaceholder.year, this.fechaNacimientoPlaceholder.month, this.fechaNacimientoPlaceholder.day, 0, 0, 0, 0);
      this.model.categoris = categories;

      this.subsServ.create(this.model).then(() => {
        this.model = {
          categoris: null,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          dateofBirth: null,
          deleted: false,
          email: '',
          lastname: '',
          name: ''
        }

        this.openSnackBar("Datos enviados exitosamente", "Cerrar");
      })
    }
    else {
      this.openSnackBar('Llene todos los campos y seleccione al menos una categoria', "Cerrar");
    }
  }
  selectToday() {
    this.modelDate = this.calendar.getToday();
  }
}
